module.exports = [
	{
		"mixkeys": [
			"0x80",
			"0x63"
		],
		"description_zh": "复制,CV工程师必备",
		"description_en": "Copy, a must for CV engineers"
	},
	{
		"mixkeys": [
			"0x80",
			"0x76"
		],
		"description_zh": "粘贴,CV工程师必备",
		"description_en": "Paste, a must for CV engineers"
	},
	{
		"mixkeys": [
			"0x83",
			"0x76"
		],
		"description_zh": "Windows粘贴,CV工程师必备",
		"description_en": "Windows paste, a must for CV engineers"
	},
	{
		"mixkeys": [
			"0x83",
			"0x6C"
		],
		"description_zh": "锁屏,下班走人!!",
		"description_en": "Lock screen, go home!!"
	},
	{
		"mixkeys": [
			"0x80",
			"0x83",
			"0x71"
		],
		"description_zh": "Mac锁屏,下班走人!!",
		"description_en": "Lock screen for MacOS, go home!!"
	},
	{
		"mixkeys": [
			"0x83",
			"0x63"
		],
		"description_zh": "Mac复制,用苹果的CV工程师必备",
		"description_en": "Copy for MacOS, a must for CV engineers"
	},
	{
		"mixkeys": [
			"0x83",
			"0x76"
		],
		"description_zh": "Mac粘贴,用苹果的CV工程师必备",
		"description_en": "Paste for MacOS, a must for CV engineers"
	},
	{
		"mixkeys": [
			"0x80",
			"0x82",
			"0xD8"
		],
		"description_zh": "IDEA返回上一步位置,IDEA程序员必备",
		"description_en": "IDEA returns to the previous position, a must for IDEA programmers"
	},
	{
		"mixkeys": [
			"0x80",
			"0x82",
			"0xD7"
		],
		"description_zh": "IDEA前进到下一步位置,IDEA程序员必备",
		"description_en": "IDEA advances to the next step, a must for IDEA programmers"
	},
	{
		"mixkeys": [
			"0x80",
			"0xCD"
		],
		"description_zh": "IDEA显示当前文件结构,好用",
		"description_en": "IDEA displays the current file structure, easy to use"
	},
	{
		"mixkeys": [
			"0x80",
			"0x61"
		],
		"description_zh": "全选",
		"description_en": "Select all"
	},
	{
		"mixkeys": [
			"0x80",
			"0x7A"
		],
		"description_zh": "撤销",
		"description_en": "Redo"
	},
	{
		"mixkeys": [
			"0x80",
			"0x79"
		],
		"description_zh": "恢复",
		"description_en": "Undo"
	},
	{
		"mixkeys": [
			"0x83",
			"0x64"
		],
		"description_zh": "回到桌面",
		"description_en": "Back to desktop"
	},
	{
		"mixkeys": [
			"0x83",
			"0x72"
		],
		"description_zh": "运行",
		"description_en": "Run"
	},
	{
		"mixkeys": [
			"0x80",
			"0x82",
			"0xD4"
		],
		"description_zh": "不解释",
		"description_en": "..."
	},
	{
		"mixkeys": [
			"0x82",
			"0xB3"
		],
		"description_zh": "快速切换程序",
		"description_en": "Quick switch program"
	},
	{
		"mixkeys": [
			"0x83",
			"0xB3"
		],
		"description_zh": "显示最近程序",
		"description_en": "Show recent programs"
	},
	{
		"mixkeys": [
			"0x82",
			"0xC5"
		],
		"description_zh": "关闭当前程序",
		"description_en": "Close current program"
	},
	{
		"mixkeys": [
			"0x80",
			"0xB3"
		],
		"description_zh": "快速切换程序内页面",
		"description_en": "Quickly switch pages in the program"
	},
	{
		"mixkeys": [
			"0x80",
			"0x66"
		],
		"description_zh": "搜索",
		"description_en": "Search"
	},
	{
		"mixkeys": [
			"0x83",
			"0x81",
			"0x73"
		],
		"description_zh": "快速截图",
		"description_en": "Quick screenshot"
	},
	{
		"mixkeys": [
			"0x81",
			"0x83",
			"0x34"
		],
		"description_zh": "Mac快速截图",
		"description_en": "Quick screenshot for MacOS"
	},
	{
		"mixkeys": [
			"0x83",
			"0x2B"
		],
		"description_zh": "放大镜",
		"description_en": "Zoom in"
	},
	{
		"mixkeys": [
			"0x83",
			"0x2D"
		],
		"description_zh": "缩小镜",
		"description_en": "Zoom out"
	},
	{
		"mixkeys": [
			"0x80",
			"0xD2"
		],
		"description_zh": "跳到页首",
		"description_en": "Go to top of page"
	},
	{
		"mixkeys": [
			"0x80",
			"0xD5"
		],
		"description_zh": "跳到页尾",
		"description_en": "Go to end of page"
	},
	{
		"mixkeys": [
			"0x81",
			"0x67"
		],
		"description_zh": "vi跳到页尾",
		"description_en": "Go to end of page for Vi"
	},
	{
		"mixkeys": [
			"0x67",
			"0x67"
		],
		"description_zh": "vi跳到页首",
		"description_en": "Go to top of page for Vi"
	},
	{
		"mixkeys": [
			"0x80",
			"0x81",
			"0xB1"
		],
		"description_zh": "打开任务管理器",
		"description_en": "Open task manager"
	},
	{
		"mixkeys": [
			"0x82",
			"0x20",
			"0x78"
		],
		"description_zh": "最大化窗口",
		"description_en": "Maximize the window"
	},
	{
		"mixkeys": [
			"0x82",
			"0x20",
			"0x72"
		],
		"description_zh": "还原窗口",
		"description_en": "Restore the window size"
	}
];


//////////////////
// WEBPACK FOOTER
// ./common.json
// module id = 93
// module chunks = 1